<template>
  <div class="login-expiration">
    <div class="login-box">
      <div class="title">登录过期，重新登录</div>
      <el-form label-position="top" ref="form" :rules="rules" :model="form" class="form">
        <el-form-item class="username-form-item" label="账户" prop="username">
          <el-input size="medium" prefix-icon="el-icon-user" v-model.trim="form.username" placeholder="请输入账户" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input size="medium" type="password" show-password prefix-icon="el-icon-lock" v-model.trim="form.password" placeholder="请输入密码" @keyup.enter.native="submit" />
        </el-form-item>
      </el-form>
      <div class="login-footer">
        <el-button class="login-btn" size="medium" type="primary" :loading="loading" @click="login">登 陆</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { encrypt } from '@/utils/encryp'
import store from '@/store'
import router from '@/router'
export default {
  data() {
    let checkUsername = (rule, value, callback) => {
      let reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/
      if (!value) {
        callback(new Error('请输入账户'))
      } else if (!reg.test(value)) {
        callback(new Error('邮箱格式不正确'))
      } else {
        callback()
        this.$refs.form.clearValidate('username')
      }
    }

    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
        this.$refs.form.clearValidate('password')
      }
    }
    return {
      rules: {
        username: [{ validator: checkUsername, trigger: ['blur', 'change'] }],
        password: [{ validator: checkPassword, trigger: ['blur', 'change'] }]
      },
      form: {
        grant_type: 'password', // 请求模式
        client_id: 'client_admin', // 客户端唯一ID
        client_secret: 'admin_secret', // 客户端密秘钥
        username: '', // 用户名
        password: '' // 密码
      },
      loading: false
    }
  },
  methods: {
    removeLoginBox() {
      document.querySelectorAll('.login-expiration').forEach(item => {
        item.remove()
      })
    },

    // 密码输入框的回车事件
    submit() {
      this.login()
    },

    // 登陆
    login() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return false
        let form = { ...this.form }
        let formData = new FormData()
        formData.append('grant_type', form.grant_type)
        formData.append('client_id', form.client_id)
        formData.append('client_secret', form.client_secret)
        formData.append('username', form.username)
        formData.append('password', encrypt(form.password))

        API.login(formData).then(res => {
          console.log(res)
          if (res.code !== 10000) {
            if (res.code === 250043) {
              store.dispatch('user/logout')
              router.replace('/login')
              this.removeLoginBox()
            }
            return this.$message.error(res.message)
          }
          let data = res.data
          // 只有角色是3||4||10（管理员||超管||客服）才能登陆后台
          // if (!(data.authorities.includes('3') || data.authorities.includes('4') || data.authorities.includes('10'))) {
          //   this.loading = false
          //   throw new Error('账号密码错误')
          // }
          let userInfo = {
            id: data.userId,
            name: data.fullName,
            role: data.authorities.includes('4') ? '4' : data.authorities[0],
            // isGetPermission: 0
          }
          store.dispatch('user/setUserInfo', userInfo)
          store.dispatch('user/setToken', data.accessToken)
          this.removeLoginBox()
          this.$refs.form.resetFields()
        }).catch(result => {
          this.$message.error(result.message)
        })
        .finally(() => {
          this.loading = false
        })
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.login-expiration {
  position: fixed;
  background: rgba(0, 0, 0, .4);
  width: 100vw;
  height: 100vh;
  z-index: 3000;
  overflow: hidden;
  top: 0;

  .login-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 350px;
    height: 340px;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;

    .title {
      text-align: center;
    }

    .form {
      margin-top: 10px;
    }

    .login-footer {
      padding-top: 20px;
      /deep/ button {
        width: 100%;
      }
    }

    /deep/ .el-form-item__label{
      padding: 0;
    }
  }
}
</style>
